import { Button, Form, Input, Result, Row } from 'antd'
import classnames from 'classnames'
import React, { memo } from 'react'
import styles from './index.module.less'

export default memo(function SuccessOrganization() {
  const [form] = Form.useForm()

  return (
    <div className={classnames('py-3', styles.container)}>
      <div className={classnames('container-xl px-3', styles.content)}>
        <Result
          style={{ width: '600px' }}
          status='success'
          title='Congratulations on your success'
          subTitle='Invite organization members'
          extra={
            <Form form={form} autoComplete='off' layout='vertical' onFinish={(values) => {}}>
              <Form.Item
                label='Member email'
                name='email'
                rules={[
                  { required: true, message: 'Please enter member email' },
                  { type: 'email', message: 'Invalid email format' }
                ]}
              >
                <Input type='email' />
              </Form.Item>

              <Form.Item>
                <Row justify='center'>
                  <Button htmlType='submit' type='primary' style={{ width: '250px' }}>
                    invitation
                  </Button>
                </Row>
              </Form.Item>

              <Form.Item>
                <Row justify='center'>
                  <Button htmlType='button' type={'text'}>
                    ignore
                  </Button>
                </Row>
              </Form.Item>
            </Form>
          }
        />
      </div>
    </div>
  )
})
